import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";

import { Figure } from "components/docs/Figure";
import { Color, magma, dmax, dmin } from "../../../styles/magma/_variables";
import * as styles from "./styles.module.scss";

const SourceCode = ({
  children,
  title,
  iconName = "CodeTags",
  showIcon = true,
  className,
  ...other
}) => {
  const baseColor = magma.foundation02;
  const titleBgColor = Color.mix(baseColor, dmax, 0);
  const stageBgColor = Color.mix(baseColor, dmax, 55);
  const iconColor = Color.mix(baseColor, dmin, 35).saturate(15);

  return (
    <Figure
      {...other}
      style={{
        "--icon-color": iconColor,
        "--stage-bgcolor": stageBgColor,
        "--title-bgcolor": titleBgColor,
      }}
      subject={children}
      title={title}
      figureTypeName="Source Code"
      iconName={iconName}
      showIcon={showIcon}
      className={classNames(styles.SourceCode, "SourceCode", className)}
    />
  );
};

export { SourceCode };
